import { render, staticRenderFns } from "./DocsLayout.vue?vue&type=template&id=f133c752"
import script from "./DocsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsLayout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports